/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */
/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { BodyJobsetApproval } from "client";
import { useApproveTask } from "hooks/ApproveTaskHook";
import { useCallApi } from "hooks/CallApiHook";
import { useState } from "react";

export const useSubmit = () => {
  const [request, setApproveRequest] = useState<BodyJobsetApproval>();
  const [approveCompleted, setApproveCompleted] = useState(false);
  const { requestApprove, cancelApprove } = useApproveTask();

  const result = useCallApi(
    async () => {
      if (request !== undefined) {
        // Approve request
        await requestApprove(request);

        setApproveCompleted(true);
      } else {
        setApproveCompleted(false);
      }
    },
    cancelApprove,
    [request, requestApprove, cancelApprove]
  );

  return { ...result, setApproveRequest, approveCompleted };
};
